import { buildRefs, getJSON } from '@helper/helpers'
import { initialiseSwiperSlider } from '@helper/swipers'
import { Autoplay, A11y, Navigation, EffectFade } from 'swiper/modules'

/**
 * Build Swiper configuration object for Hero Slider
 *
 * @param {Object} refs - DOM element references
 * @param {Object} data - Block configuration data
 * @return {Object} Swiper configuration object
 */
const getConfig = (refs, data) => {
  const modules = [A11y, EffectFade]
  const hasNavigation = data.hasNavigation && data.slideCount > 1

  if (data.autoplay) modules.push(Autoplay)
  if (hasNavigation) modules.push(Navigation)

  const config = {
    modules,
    slidesPerView: 1,
    speed: data.speed,
    loop: data.loop,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    watchSlidesProgress: false,
    a11y: {
      prevSlideMessage: data.i18n.prevSlideMessage,
      nextSlideMessage: data.i18n.nextSlideMessage,
      paginationBulletMessage: data.i18n.paginationBulletMessage,
      firstSlideMessage: data.i18n.firstSlideMessage,
      lastSlideMessage: data.i18n.lastSlideMessage,
    },
  }

  if (hasNavigation && refs.prevEl && refs.nextEl) {
    config.navigation = {
      nextEl: refs.nextEl,
      prevEl: refs.prevEl,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
    }
  }

  if (data.autoplay) {
    config.autoplay = {
      delay: data.autoplayDelay,
      disableOnInteraction: data.autoplayDisableOnInteraction,
      pauseOnMouseEnter: true,
      reverseDirection: false,
      stopOnLastSlide: false,
    }
  }

  return config
}

export default function HeroSlider(el) {
  const refs = buildRefs(el)
  const data = getJSON(el)

  if (!refs.swiper || !data) {
    console.warn('HeroSlider: Required elements or data missing')
    return null
  }

  const sliderId =
    refs.swiper.dataset.id ||
    `hero-slider-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

  const swiper = initialiseSwiperSlider(
    sliderId,
    refs.swiper,
    getConfig(refs, data)
  )

  if (!swiper) {
    console.error('HeroSlider: Failed to initialize Swiper')
    return null
  }

  return () => {
    if (swiper && typeof swiper.destroy === 'function') {
      swiper.destroy(true, true)
    }
  }
}
